import { render, staticRenderFns } from "./add-modal.vue?vue&type=template&id=1af2e8da&scoped=true&"
import script from "./add-modal.vue?vue&type=script&lang=ts&"
export * from "./add-modal.vue?vue&type=script&lang=ts&"
import style0 from "./add-modal.vue?vue&type=style&index=0&id=1af2e8da&prod&lang=css&"
import style1 from "./add-modal.vue?vue&type=style&index=1&id=1af2e8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af2e8da",
  null
  
)

export default component.exports